import { Link, Typography } from '@mui/material';
import { mapDispatchToProps, mapStateToProps } from './ReselectMFA.container';

import Locale from '/b2b/common/components/Locale';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import UnauthenticatedPaths from '/b2b/routing/UnauthenticatedRoutes/UnauthenticatedRoutes.paths';
import { connect } from 'react-redux';

// eslint-disable-next-line no-use-before-define
export default connect(mapStateToProps, mapDispatchToProps)(ReselectMFA);

export function ReselectMFA(props) {
    const { hasOtherMFAMethods, mfaType, onReselectMFA } = props;
    let type = mfaType;

    switch (mfaType) {
        case 'TOTP':
        case 'SOFTWARE_TOKEN_MFA': {
            type = 'auth.amplify.mfa.totp.title';
            break;
        }

        case 'SMS':
        case 'SMS_MFA': {
            type = 'auth.amplify.mfa.sms.title';
            break;
        }
    }

    return hasOtherMFAMethods ? (
        <Typography mt={2} variant="body1">
            <Locale path="auth.amplify.mfa.reselect.cta" options={{ type }} />{' '}
            <Link
                fontWeight="bold"
                component={RouterLink}
                to={UnauthenticatedPaths.SELECT_MFA}
                onClick={onReselectMFA}
            >
                <Locale path="auth.amplify.mfa.reselect.link" />
            </Link>
        </Typography>
    ) : null;
}

ReselectMFA.propTypes = {
    mfaType: PropTypes.string,
    hasOtherMFAMethods: PropTypes.bool,
    onReselectMFA: PropTypes.func.isRequired,
};
